import { React, UseState, UseEffect } from 'react';
import { useTranslation } from 'react-i18next';
import PageContent from 'layouts/PageContent';
import MonthlyDash from './MonthlyDash';

const MonthlySalesScreen = (props) => {
  const {t, i18n} = useTranslation(['salesPerformance', 'common']);
  
  return (
    <PageContent title={t('salesPerformance:MonthlySalesDashboard')}>
      <MonthlyDash />
    </PageContent>
  )
}

export default MonthlySalesScreen;